// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tooltip/style/index.less
// module id = 1122
// module chunks = 1